import { lazy } from 'react';

// Create a map of route to import function for prefetching
export const routeConfig = {
    '/': () => import('./pages/Home'),
    '/creator': () => import('./pages/CreatorPage'),
    '/viewer': () => import('./pages/ViewerPage'),
    '/hoister': () => import('./pages/HoisterPage'),
    '/about': () => import('./pages/AboutPage'),
    '/contact': () => import('./pages/ContactPage'),
    '/privacy': () => import('./pages/PrivacyPage'),
    '/terms': () => import('./pages/TermsPage'),
    '/cookies': () => import('./pages/CookiesPage'),
    '/how-it-works': () => import('./pages/HowItWorksPage'),
    '/documentation': () => import('./pages/DocumentationPage'),
    '/api-reference': () => import('./pages/APIReferencePage'),
    '/community': () => import('./pages/CommunityPage'),
    '/blog': () => import('./pages/BlogPage'),
};

// Create the lazy components
export const Home = lazy(routeConfig['/']);
export const CreatorPage = lazy(routeConfig['/creator']);
export const ViewerPage = lazy(routeConfig['/viewer']);
export const HoisterPage = lazy(routeConfig['/hoister']);
export const AboutPage = lazy(routeConfig['/about']);
export const ContactPage = lazy(routeConfig['/contact']);
export const PrivacyPage = lazy(routeConfig['/privacy']);
export const TermsPage = lazy(routeConfig['/terms']);
export const CookiesPage = lazy(routeConfig['/cookies']);
export const HowItWorksPage = lazy(routeConfig['/how-it-works']);
export const DocumentationPage = lazy(routeConfig['/documentation']);
export const APIReferencePage = lazy(routeConfig['/api-reference']);
export const CommunityPage = lazy(routeConfig['/community']);
export const BlogPage = lazy(routeConfig['/blog']);

// Utility to prefetch a route
export const prefetchRoute = (path) => {
    const importFn = routeConfig[path];
    if (importFn) {
        importFn();
    }
};
